import {Component, EventEmitter, OnInit, Input, Output} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { PageNotificationService } from '@signature-it/ngx-generic/services';
import { CartService } from '@signature-it/ngx-catalogue/services';
import {TranslateService} from "@ngx-translate/core";

declare let _: any;

@Component({
    selector: 'cart-coupon',
    templateUrl: './coupon.html',
    styleUrls: ['./coupon.scss'],
    standalone: false
})
export class CartCouponComponentGeneric  implements OnInit {

    @Input() useOneCoupon: boolean = false;
    @Input() showErrorNotification: boolean = true;
    @Input() showErrorMessage: boolean = false;
    @Output() updateTotalPrice = new EventEmitter();

    form: UntypedFormGroup;
    submitSpinner: boolean = false;
    coupons: Array<string>;
    removeSpinner = {};
    errorMessage = '';

	constructor(protected fb: UntypedFormBuilder,
                protected notifySvc: PageNotificationService,
                protected cartSvc: CartService,
                protected translateSvc: TranslateService) {
        this.form = fb.group({
            coupon: ['', [Validators.required]]
        });
    }

    ngOnInit() {
        this.getCouponsUsages();
    }

    submitForm() {
        if (!this.form.invalid) {
            this.submitSpinner = true;
            this.cartSvc.checkCoupon(this.form.value)
                .subscribe(
                    (data: any) => {
                        if (!_.isObject(JSON.parse(data))) {
                            if (this.showErrorNotification) this.notifySvc.set(this.translateSvc.instant(JSON.parse(data))).show();
                            if (this.showErrorMessage) this.errorMessage = this.translateSvc.instant(JSON.parse(data));
                        } else {
                            this.getCouponsUsages();
                            this.onUpdateTotalPrice();
                        }
                        this.submitSpinner = false;
                    },
                    error => {
                        this.notifySvc.set(error).show();
                        this.submitSpinner = false;
                    }
           );
        }
    }

    removeCoupon(coupon) {
        this.submitSpinner = true;
        this.cartSvc.removeCoupon(coupon)
            .subscribe(
                (data: any) => {
                    this.getCouponsUsages();
                    this.onUpdateTotalPrice();
                    this.resetForm();

                    this.submitSpinner = false;
                },
                error => {
                    this.notifySvc.set(error).show();
                    this.submitSpinner = false;
                }
            );

    }

    onUpdateTotalPrice() {
	    this.updateTotalPrice.next(true);
    }

    resetForm() {
        this.submitSpinner = false;
        this.form.reset();
    }
    getCouponsUsages(){
        this.cartSvc.getCouponsUsages()
            .subscribe(
                (data: any) => {
                    this.coupons = data;
                    this.submitSpinner = false;
                    if (this.useOneCoupon && data.length) {
                        this.form.get('coupon').setValue(data[0].coupon_code);
                    }
                },
                error => {
                    this.notifySvc.set(error).show();
                    this.submitSpinner = false;
                }
            );
    }

}
